export default __webpack_public_path__ + "static/media/WeRead.27a28983.png";